import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module.js";

/** Warm the same Meshopt GLTFLoader path GltfRoom / StaticGltfProp use at render. */
export function preloadGltfUrls(urls: string[]) {
  for (const url of urls) {
    if (!url) continue;
    useLoader.preload(GLTFLoader, url, (loader) => {
      (loader as GLTFLoader).setMeshoptDecoder(MeshoptDecoder);
    });
  }
}
